export default class Selectors {

    constructor(options = {}) {
        this.dataAttrId = options.dataAttrId || 'data-id';
    }

    querySelectorArray(selector, element = null) {
        if (element) {
            return Array.prototype.slice.call(element.querySelectorAll(selector));
        }
        return Array.prototype.slice.call(document.querySelectorAll(selector));
    }

    attrSelector(name, value = undefined) {
        if (value) {
            return '[' + name + '="' + value + '"]';
        }
        return '[' + name + ']';
    }

    nameAttr(value) {
        return this.attrSelector('name', value);
    }

    dataAttr(value) {
        return this.attrSelector(this.dataAttrId, value);
    }

    modalDataAttr(value) {
        return this.attrSelector('data-modal-id', value);
    }
}
